import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import styles from "./layout.module.scss"
import BrandsContainer from "../components/BrandsContainer/BrandsContainer.js"
import Footer from "../components/Footer/Footer.js"
import Contact from "../components/Contact/Contact.js"

import './index.css'

const Header = () => (
  <div className={styles.header}>
    <div className={styles.headerInner}>
      <h1 >
        <Link className={styles.title}
          to="/"
        >
          Luke Edmonds
        </Link>
      </h1>
    </div>
  </div>
)

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Luke Edmonds - Front End Developer Leeds"
      meta={[
        { name: 'description', content: 'I am Luke Edmonds. A Front end web developer based in Leeds, England.' },
        { name: 'keywords', content: 'freelance, contract, front end developer, ui ux developer, responsive ux ui developer, front end dev leeds, react developer leeds' },
      ]}
    />
    <div className={styles.topWrapper}>
      <Header />
      <div className={styles.container}>
        <h2 className={styles.strapline}>
          I'm Luke. A Front end web developer based in Leeds, England.
        </h2>
      </div>
    </div>
    <BrandsContainer />
    <Contact />
    {/*children()*/}
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js